import { render, staticRenderFns } from "./DetailSelect.vue?vue&type=template&id=2cc3a6ac&scoped=true"
import script from "./DetailSelect.vue?vue&type=script&lang=js"
export * from "./DetailSelect.vue?vue&type=script&lang=js"
import style0 from "./DetailSelect.vue?vue&type=style&index=0&id=2cc3a6ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3a6ac",
  null
  
)

export default component.exports